import {DonateComponent, DonateComponentStyle} from "../../pages/panels/donation/components/DonateComponent";
import {DonateAmountButtonList} from "../../../common/donate/DonateAmountButtonList";
import {DonateActiveButtonList} from "../../../common/donate/DonateActiveButtonList";
import {MerchantActiveButton, MerchantActiveButtonStyle} from "../../../common/donate/MerchantActiveButton";
import {
    CustomAmountButton,
    CustomCurrencyInput,
    CustomCurrencyInputStyle
} from "../../../common/donate/CustomAmountButton";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";


class DonateHomeCustomCurrencyInputStyle extends CustomCurrencyInputStyle {
    @styleRuleInherit
    inputContainer = {
        height: 34,
    };

    @styleRuleInherit
    currency = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
    };

    @styleRuleInherit
    input = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        caretColor: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_ACTIVE_COLOR,
    };
}

@registerStyle(DonateHomeCustomCurrencyInputStyle)
class DonateHomeCustomCurrencyInput extends CustomCurrencyInput {}

class DonateHomeDonateActiveButtonStyle extends MerchantActiveButtonStyle {
    @styleRuleInherit
    button = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        borderRadius: 2,
        height: 37,
        border: "1px solid " + this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_BORDER_COLOR,
        background: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_BACKGROUND,
        color: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_COLOR,
        ":hover": {
            background: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_HOVER_BACKGROUND,
        },
    };

    @styleRule
    active = {
        color: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_ACTIVE_COLOR,
        background: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_ACTIVE_BACKGROUND,
        boxShadow: "",
        ":hover": {
            background: this.themeProps.DONATE_PAGE_ACTIVE_BUTTON_ACTIVE_HOVER_BACKGROUND,
        }
    };
}

@registerStyle(DonateHomeDonateActiveButtonStyle)
class DonateHomeDonateActiveButton extends MerchantActiveButton {}

@registerStyle(DonateHomeDonateActiveButtonStyle)
class DonateHomeCustomAmountButton extends CustomAmountButton {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            CustomCurrencyInputClass: DonateHomeCustomCurrencyInput,
        };
    }
}

class DonateHomeDonateAmountButtonList extends DonateAmountButtonList {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            CustomAmountButtonClass: DonateHomeCustomAmountButton,
            ButtonClass: DonateHomeDonateActiveButton,
        };
    }
}

class DonateHomeDonateActiveButtonList extends DonateActiveButtonList {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            ButtonClass: DonateHomeDonateActiveButton
        };
    }
}

export class DonateHomeDonateComponentStyle extends DonateComponentStyle {
    @styleRuleInherit
    title = this.themeProps.DONATE_PAGE_CARD_TITLE;
}

@registerStyle(DonateHomeDonateComponentStyle)
export class DonateHomeDonateComponent extends DonateComponent {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            feeCheckboxLabel: Messages.donatePageFeeCheckbox,
            DonateAmountButtonListClass: DonateHomeDonateAmountButtonList,
            DonateActiveButtonListClass: DonateHomeDonateActiveButtonList,
        };
    }
}
